import {
  CmdFromRenderer,
  CmdTypeFromRender,
  StartCmdparam,
  StopCmdParam,
  TurnOffEngineCmdParam,
} from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/ServiceCommand/CmdFromRenderer';
import { ITimingStrategy } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/ITimingStrategy';
import { TimingStrategyDelegate } from '@/renderer/scripts/CoSync/SyncCenter/ServiceMgr/TimingStrategy/TimingStrategyDelegate';
import { CoSyncInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import { CoSynStatusInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncEvent';

export class AutoTimingStrategy implements ITimingStrategy {
  constructor(servceDelegate: WeakRef<TimingStrategyDelegate>, coSyncInfo: CoSyncInfo) {
    this.servceDelegate = servceDelegate;
    this.coSyncInfo = coSyncInfo;
  }

  private servceDelegate: WeakRef<TimingStrategyDelegate>;
  private coSyncInfo: CoSyncInfo;

  /**
   * 处理恢复上一次的状态
   * 根据上一次关闭的情况来恢复
   *
   * @memberof AutoTimingStrategy
   */
  public handleRestore(): void {
    switch (this.coSyncInfo.config.syncSetting.keepWhichLastStatus) {
      case 'started':
        this.start();
        break;

      default:
        this.restoreStop();
        break;
    }
  }

  /**
   * 处理创建后的初次状态
   *
   * @memberof AutoTimingStrategy
   */
  public handleJustCreated(): void {
    this.start();
  }

  /**
   * 处理开始
   * 自动模式下开始就启动引擎
   *
   * @return {*}  {Promise<void>}
   * @memberof AutoTimingStrategy
   */
  public async handleStart(): Promise<void> {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('handleStart aServceDelegate is undefined');
      return;
    }
    await aServceDelegate.applyCommand({ cmdType: CmdTypeFromRender.TURN_ON_ENGINE } as CmdFromRenderer);
  }

  /**
   * 处理停止
   * 自动模式下开始就关闭引擎
   *
   * @return {*}  {Promise<void>}
   * @memberof AutoTimingStrategy
   */
  public async handleStop(stopParam: StopCmdParam): Promise<void> {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('handleStop aServceDelegate is undefined');
      return;
    }
    await aServceDelegate.applyCommand({
      cmdType: CmdTypeFromRender.TURN_OFF_ENGINE,
      param: { isSilent: stopParam.isSilent ?? false } as TurnOffEngineCmdParam,
    } as CmdFromRenderer);
  }

  public async onUpdateStatus(status: CoSynStatusInfo): Promise<void> {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('restoreNone aServceDelegate is undefined');
      return;
    }

    aServceDelegate.emitTaskChange(status);
  }

  private start() {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('start aServceDelegate is undefined');
      return;
    }

    const startParam: StartCmdparam = {
      isFromUIAction: false,
    };
    const startCmd: CmdFromRenderer = {
      cmdType: CmdTypeFromRender.START,
      param: startParam,
    };
    aServceDelegate.applyCommand(startCmd);
  }

  private restoreStop() {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('restoreStop aServceDelegate is undefined');
      return;
    }

    // 如果是停止的话，要通知一次停止的状态
    aServceDelegate.emitTaskChange(aServceDelegate.buildStopStatus());
  }

  private restoreIdel() {
    const aServceDelegate = this.servceDelegate.deref();
    if (!aServceDelegate) {
      logger.ui.error('restoreNone aServceDelegate is undefined');
      return;
    }

    // 如果没有上一次状态（新创建的），要通知一次等待中的状态
    aServceDelegate.emitTaskChange(aServceDelegate.buildIdleStatus());
  }
}
